import { createContext, useContext } from 'react'
import type {
  ChatSelectionAction,
  ChatSelectionState,
  ChatSelectionToken,
} from '../types/aiChatSource'

export type ChatSelectionContextValue = ChatSelectionState & {
  dispatch: (action: ChatSelectionAction) => void
  setMode: (mode: ChatSelectionState['mode']) => void
  toggleToken: (token: ChatSelectionToken) => void
  removeToken: (key: string) => void
  clear: () => void
  hasToken: (token: ChatSelectionToken) => boolean
}

export const ChatSelectionContext = createContext<ChatSelectionContextValue | null>(null)

export const useChatSelection = () => {
  const context = useContext(ChatSelectionContext)
  if (!context) throw new Error('useChatSelection must be used inside ChatSelectionProvider')
  return context
}

export const useOptionalChatSelection = () => useContext(ChatSelectionContext)
